import { createAction, props } from '@ngrx/store';
import { ICategory } from '../../../shared/models/category/ICategory';
import { ICategoryFilter } from 'src/app/shared/models/category/ICategoryFilter';
import { TreeNodeItem } from 'src/app/shared/models/tree/TreeNodeItem';
import { IResponseMessage } from 'src/app/shared/models/response-message/IResponseMessage';

export const CategoriesActionTypes = {
  GET_CATEGORIES: '[CATEGORIES] get categories',
  GET_CATEGORY: '[CATEGORIES] get category',
  GET_CATEGORY_SUCCESS: '[CATEGORIES] get category success',
  GET_CATEGORIES_SUCCESS: '[CATEGORIES] get categories success',
  GET_CATEGORIES_ERROR: '[CATEGORIES] get categories error',
  GET_ITEM: '[CATEGORIES] get item',
  GET_ITEM_SUCCESS: '[CATEGORIES] get item success',
  SET_RATING: '[CATEGORIES] set rating'
};

export const GetCategories = createAction(
  CategoriesActionTypes.GET_CATEGORIES,
  props<{ application: string; filter?: ICategoryFilter }>()
);

export const GetCategoriesSuccess = createAction(
  CategoriesActionTypes.GET_CATEGORIES_SUCCESS,
  props<{ categories: ICategory[] }>()
);

export const GetCategoriesError = createAction(
  CategoriesActionTypes.GET_CATEGORIES_ERROR,
  props<{ error: IResponseMessage }>()
);

export const GetCategoryItem = createAction(
  CategoriesActionTypes.GET_ITEM,
  props<{ application: string; id: string }>()
);

export const GetCategoryItemSuccess = createAction(
  CategoriesActionTypes.GET_ITEM_SUCCESS,
  props<{ item: TreeNodeItem }>()
);

export const GetCategory = createAction(
  CategoriesActionTypes.GET_CATEGORY,
  props<{ application: string; id: string }>()
);

export const GetCategorySuccess = createAction(
  CategoriesActionTypes.GET_CATEGORY_SUCCESS,
  props<{ category: ICategory }>()
);

export const SetRating = createAction(CategoriesActionTypes.SET_RATING, props<{ id: string; rating: string }>());
